import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'utils/DocumentTitle';

import {
  dataRequest,
  selectItemById,
  selectRequestsStateById
} from 'mt-react-common/common/reducers/objectCollection/reducer';

import connect from 'react-redux/es/connect/connect';

import MediumPreLoader from '../../../../../components/Common/PreLoaders/MediumPreLoader';
import Content from './Content';

const tasksCollectionRName = 'tasksModule.collections.tasksCollection';

class TaskViewAsExecutor extends Component {
  constructor(props) {
    super(props);
    this.props.sendRequest();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    if (this.props.requestState.requestInProcess || !this.props.task) {
      return <MediumPreLoader />;
    }
    return (
      <DocumentTitle title={this.props.task.title}>
        <Content {...this.props} />
      </DocumentTitle>
    );
  }
}

TaskViewAsExecutor.defaultProps = {
  task: null
};

TaskViewAsExecutor.propTypes = {
  // CONNECT
  sendRequest: PropTypes.func.isRequired,
  requestState: PropTypes.shape({
    requestInProcess: PropTypes.bool.isRequired,
    lastStatusCode: PropTypes.number
  }).isRequired,
  task: PropTypes.shape({
    title: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    ownerId: PropTypes.number.isRequired,
    taskCommentsStat: PropTypes.shape({})
  })
};

const mapStateToProps = (state, props) => ({
  requestState: selectRequestsStateById(
    state,
    tasksCollectionRName,
    props.match.params.taskId
  ),
  task: selectItemById(state, tasksCollectionRName, props.match.params.taskId)
});

// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = (dispatch, props) => ({
  sendRequest: () =>
    dispatch(dataRequest(tasksCollectionRName, props.match.params.taskId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TaskViewAsExecutor);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/TaskViewAsExecutor/index.js